import {colors} from '../../defaultSettings';

export default {
  container: {
    position: 'absolute',
    left: '15px',
    top: '55px',
    right: 'auto',
    zIndex: 4,
    boxShadow: '0 2px 12px rgba(0,0,0,0.12)'
  },
  subMenu: {
    position: 'absolute',
    top: '55px',
    right: 'auto',
    background: colors.bg.panel,
    boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
    zIndex: 4,
  },
  title: {
    background: colors.bg.title,
    color: colors.title,
    margin: 0,
    fontSize: '1.6rem',
    padding: '5px 10px'
  },
  content: {
    background: colors.bg.panel,
    border: '1px solid ' + colors.panelBorder,
    borderBottom: 0,
    borderTop: 0,
  },
  menuItem: {
    display: 'block',
    width: '100%',
    background: 'none',
    borderBottom: '1px solid ' + colors.panelBorder,
    color: colors.textDark,
    textAlign: 'left',
    padding: '5px'
  },
  menuItemHov: {
    background: colors.highlight,
    color: colors.highlightText
  }
}
